var _style, _path, _path2, _circle, _path3, _path4, _path5, _path6, _circle2, _path7, _path8, _path9, _path0, _path1, _path10, _circle3, _path11, _path12, _circle4, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle5, _circle6, _line, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b50c90a1-13f8-40ae-8a07-2cff909416b3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-59 139.4 881 722.6",
    style: {
      enableBackground: "new -59 139.4 881 722.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C0B3BC;}\r\n\t.st1{fill:none;stroke:#3F3D56;stroke-miterlimit:10;}\r\n\t.st2{fill:#A0616A;}\r\n\t.st3{fill:#3F3D56;}\r\n\t.st4{fill:#2F2E41;}\r\n\t.st5{opacity:0.1;enable-background:new    ;}\r\n\t.st6{opacity:0.7;}\r\n\t.st7{fill:#ADADAD;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "weather app") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M605.6,754.3c0-55.3-44.8-100.1-100.1-100.1c-22.3,0-43.9,7.4-61.5,21.1C404.8,630,336.4,625,291.2,664.2 c-15.1,13.1-26.3,30-32.4,49.1c-33.3-29.6-84.4-26.6-114.1,6.7c-29.6,33.3-26.6,84.4,6.7,114.1c14.8,13.1,33.9,20.4,53.7,20.4 c1.3,0,2.5,0,3.7-0.1c1.3,0.1,2.6,0.1,3.9,0.1H516c45.2,0,83-34.3,87.4-79.3C604.8,768.3,605.6,761.3,605.6,754.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M609,742c0-55.3-44.8-100.1-100.1-100.1c-22.3,0-43.9,7.4-61.5,21.1c-39.1-45.3-107.5-50.3-152.8-11.1 c-15.1,13.1-26.3,30-32.4,49.1c-33.3-29.6-84.4-26.6-114.1,6.7c-29.6,33.3-26.6,84.4,6.7,114.1c14.8,13.1,33.9,20.4,53.7,20.4 c1.3,0,2.5,0,3.7-0.1c1.3,0.1,2.6,0.1,3.9,0.1h303.3c45.2,0,83-34.3,87.4-79.3C608.3,756,609,749,609,742z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 212.7,
    cy: 613.7,
    r: 63.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.9,474.9L212.9,474.9c8.6,0,15.6,7,15.6,15.6v31.7c0,8.6-7,15.6-15.6,15.6h0c-8.6,0-15.6-7-15.6-15.6v-31.7 C197.3,481.9,204.3,474.9,212.9,474.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333,544.5L333,544.5c4.3,7.5,1.8,17-5.7,21.3l-27.4,15.8c-7.5,4.3-17,1.8-21.3-5.7v0c-4.3-7.5-1.8-17,5.7-21.3 l27.4-15.8C319.1,534.5,328.7,537,333,544.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.4,682.9L92.4,682.9c-4.3-7.5-1.8-17,5.7-21.3l27.4-15.8c7.5-4.3,17-1.8,21.3,5.7h0c4.3,7.5,1.8,17-5.7,21.3 l-27.4,15.8C106.3,692.9,96.8,690.4,92.4,682.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.7,544.1L92.7,544.1c4.3-7.5,13.8-10,21.3-5.7l27.4,15.8c7.5,4.3,10,13.8,5.7,21.3h0 c-4.3,7.5-13.8,10-21.3,5.7l-27.4-15.8C90.9,561.1,88.3,551.6,92.7,544.1z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 220.2,
    cy: 606.2,
    r: 63.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.4,467.4L220.4,467.4c8.6,0,15.6,7,15.6,15.6v31.7c0,8.6-7,15.6-15.6,15.6h0c-8.6,0-15.6-7-15.6-15.6V483 C204.8,474.4,211.8,467.4,220.4,467.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.5,537L340.5,537c4.3,7.5,1.8,17-5.7,21.3l-27.4,15.8c-7.5,4.3-17,1.8-21.3-5.7l0,0 c-4.3-7.5-1.8-17,5.7-21.3l27.4-15.8C326.6,527,336.2,529.5,340.5,537z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.9,675.4L99.9,675.4c-4.3-7.5-1.8-17,5.7-21.3l27.4-15.8c7.5-4.3,17-1.8,21.3,5.7l0,0 c4.3,7.5,1.8,17-5.7,21.3l-27.4,15.8C113.8,685.4,104.2,682.9,99.9,675.4z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.1,536.6L100.1,536.6c4.3-7.5,13.8-10,21.3-5.7l27.4,15.8c7.5,4.3,10,13.8,5.7,21.3l0,0 c-4.3,7.5-13.8,10-21.3,5.7L105.9,558C98.4,553.6,95.8,544.1,100.1,536.6z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M556.3,724l-11,22.3c0,0-19.8-2.5-11.8,23.6c0,0-2.1,19.8-6.3,24s3.4,32,18.5,24c8.5-4.5,9.1-9.7,7.9-13.3 c-1.8-5.5-2.2-11.3-1-16.9c1.5-7.1,4.3-16.2,9.1-24.1c9.7-15.6,19-30.8,19-30.8L556.3,724z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M528.9,586.6c0,0-24-5.9-32-1.7s-31.6,4.6-31.6,4.6s-19.8,32-15.2,48.5s24,26.6,24,26.6l65.3,0.4l10.5-43 c0,0-5.1-29.5-9.3-31.2S528.9,586.6,528.9,586.6z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 507.4,
    cy: 439.5,
    r: 35.8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M485.1,470.2c0,0,4.2,17.7-2.1,19.8c-6.3,2.1-11.8,10.5-11.8,10.5l9.3,15.6l31.6,8l9.7-9.3l7.2-19.8l-7.2-5.1 c0,0-6.7,2.1-7.2-4.6c-0.2-5.1-0.1-10.1,0.4-15.2H485.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M485.1,470.2c0,0,4.2,17.7-2.1,19.8c-6.3,2.1-11.8,10.5-11.8,10.5l9.3,15.6l31.6,8l9.7-9.3l7.2-19.8l-7.2-5.1 c0,0-6.7,2.1-7.2-4.6c-0.2-5.1-0.1-10.1,0.4-15.2H485.1z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 501.3,
    cy: 456.1,
    r: 25.7
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M499.9,514.9l-24.4-22.3c0,0-11,9.3-12.2,9.3c-1.3,0-17.7,5.1-18.1,7.2s14.3,24.4,14.3,24.4s-3.4,16.4,0,23.6 c3.4,7.2,0.8,37.9,0.8,37.9s22.3-8,34.1-4.2c11.8,3.8,46.4,0,46.4,0s5.1-32.5,3-36.7s-2.5-28.2-2.5-28.2l18.1-19.8 c0,0-3.8-15.2-18.1-16c-14.3-0.8-23.2-1.7-23.2-1.7L499.9,514.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M471.2,618.6c0,0-47.2-21.5-66.2-31.6c-19-10.1-48.1-2.1-38.8,20.7c9.3,22.8,61.1,45.1,61.1,45.1 s16.9,12.6,27,12.2c10.1-0.4,24.7-0.2,24.7-0.2L471.2,618.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M544.1,621.5c0,0,84.7,0.8,79.2,32.5c-5.5,31.6-37.9,84.3-43.8,85.6s-27.4-8-27.4-11c0-3,20.7-57.3,20.7-57.3 l-50.6-15.6L544.1,621.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M560.1,527.1c0,0,5.1,48.5,2.5,56.1c-2.5,7.6-11.4,28.2-22.8,38.4c-11.4,10.1-27.4,61.1-36.2,36.7 c-8.9-24.4,14.3-37.9,14.3-37.9l23.2-32.7l0.2-53.2L560.1,527.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M465.3,628.7c0,0,41.7,14.8,46.4,12.6c4.6-2.1,14.8,5.5,14.8,5.5c9.4-2,19.3-0.2,27.4,5.1 c13.5,8.9,16.4,19,13.5,19.4c-3,0.4-13.5-4.2-13.5-4.2s-16-3.4-25.7-0.4c-9.7,3-22.3-3.3-22.3-3.3l-51.4-11.5L465.3,628.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M465.3,628.7c0,0,41.7,14.8,46.4,12.6c4.6-2.1,14.8,5.5,14.8,5.5c9.4-2,19.3-0.2,27.4,5.1 c13.5,8.9,16.4,19,13.5,19.4c-3,0.4-13.5-4.2-13.5-4.2s-16-3.4-25.7-0.4c-9.7,3-22.3-3.3-22.3-3.3l-51.4-11.5L465.3,628.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M445.1,545.2c0,0,0.4,52.3,6.7,58.6c6.3,6.3,13.1,14.8,19.4,18.5s9.7,12.6,9.7,12.6s30.3,44.3,30.8,24 c0.4-20.2-15.6-36.2-15.6-36.2l-3.1-3c-6.9-6.5-13.1-13.6-18.5-21.2c-1.2-1.8-2.8-3.5-4.5-4.8c-5.5-4.2-6.7-50.6-6.7-50.6 L445.1,545.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M550.4,501l8.9,5.1c0,0,3.4,22.3,5.1,25.3c1.7,3-20.7,10.5-24,8.4c-3.4-2.1-5.1-22.8-5.1-22.8L550.4,501z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M450.5,508.6h-5.5c0,0-5.9,6.3-5.5,19.8c0.4,13.5-5.1,21.9-1.7,23.2c3.4,1.3,20.2-5.4,20-3.6 c-0.2,1.9,8.7-1.5,8.7-1.5l-5.9-22.3L450.5,508.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M408.2,595c0,0,25.7,11,32.9,12.6c7.2,1.7,30.3,21.4,30.3,21.4l-15.8,24c0,0-16.2-2-25.1-3.7 s-61.5-36.7-52.7-42.6C386.7,600.9,408.2,595,408.2,595z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M402.9,595c0,0,25.7,11,32.9,12.6c7.2,1.7,35.4,21.1,35.4,21.1l-13.9,27c0,0-23.2-4.6-32-6.3 c-8.9-1.7-61.5-36.7-52.7-42.6C381.4,600.9,402.9,595,402.9,595z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 514.4,
    cy: 415.2,
    r: 35.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 524.5,
    cy: 379.4,
    r: 16.9
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 81.5,
    y1: 854.3,
    x2: 681.5,
    y2: 854.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M447.6,297.8c0,0.7-0.3,1.4-0.8,1.9c-0.5,0.5-1.2,0.8-2,0.8h-20c-1.1,0-2.1-0.3-2.9-0.9 c-0.8-0.6-1.1-1.4-1.1-2.4c0-1,0.3-2,1-2.7l18.4-21.2h-16.2c-0.7,0-1.4-0.3-1.9-0.8c-0.5-0.5-0.8-1.1-0.8-1.9c0-0.7,0.3-1.4,0.8-2 c0.5-0.6,1.2-0.9,2-0.9h19.4c1.1,0,2.1,0.3,2.7,1c0.7,0.7,1,1.5,1,2.6c0,1-0.3,1.9-0.9,2.7L428.4,295h16.4c0.7,0,1.4,0.3,1.9,0.9 C447.3,296.4,447.6,297,447.6,297.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M561.7,314.8c0,0.7-0.3,1.4-0.8,1.9c-0.5,0.5-1.2,0.8-2,0.8h-20c-1.1,0-2.1-0.3-2.9-0.9 c-0.8-0.6-1.1-1.4-1.1-2.4c0-1,0.3-2,1-2.7l18.4-21.2h-16.2c-0.7,0-1.4-0.3-1.9-0.8c-0.5-0.5-0.8-1.1-0.8-1.9c0-0.7,0.3-1.4,0.8-2 c0.5-0.6,1.2-0.9,2-0.9h19.4c1.1,0,2.1,0.3,2.7,1c0.7,0.7,1,1.5,1,2.6c0,1-0.3,1.9-0.9,2.7L542.6,312H559c0.7,0,1.4,0.3,1.9,0.9 C561.4,313.4,561.7,314,561.7,314.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M571.8,190.4c0,0.5-0.2,1-0.6,1.4c-0.4,0.4-0.9,0.6-1.5,0.6h-15c-0.9,0-1.6-0.2-2.1-0.6 c-0.6-0.4-0.8-1-0.8-1.8c0-0.8,0.3-1.5,0.8-2.1l13.8-15.9h-12.1c-0.5,0-1-0.2-1.4-0.6c-0.4-0.4-0.6-0.9-0.6-1.4 c0-0.5,0.2-1,0.6-1.5c0.4-0.4,0.9-0.6,1.5-0.6h14.5c0.9,0,1.5,0.3,2.1,0.8c0.5,0.5,0.8,1.2,0.8,1.9c0,0.8-0.2,1.4-0.7,2l-13.4,15.7 h12.3c0.5,0,1,0.2,1.4,0.6C571.6,189.4,571.8,189.9,571.8,190.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M529.2,260.4c0,1.1-0.4,2-1.2,2.8c-0.8,0.8-1.8,1.2-2.9,1.2h-30c-1.7,0-3.1-0.4-4.3-1.3 c-1.1-0.9-1.7-2.1-1.7-3.6c0-1.6,0.5-2.9,1.5-4.1l27.7-31.8H494c-1.1,0-2.1-0.4-2.9-1.2c-0.8-0.8-1.2-1.7-1.2-2.8 c0-1.1,0.4-2.1,1.2-2.9c0.8-0.9,1.8-1.3,2.9-1.3h29.1c1.7,0,3.1,0.5,4.1,1.5c1,1,1.5,2.3,1.5,3.9c0,1.6-0.5,2.9-1.4,4l-26.8,31.4 h24.6c1.1,0,2.1,0.4,2.9,1.3C528.8,258.4,529.2,259.3,529.2,260.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/Preview.b9c7deb389495ed8d92ff7d3aa678e10.svg";
export { ForwardRef as ReactComponent };